import React, { useEffect, useState } from "react";
import SocialMedia from "./SocialMedia";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS library

export default function Contact() {
  const [result, setResult] = useState("");

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Whether animation should happen only once
    });
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    formData.append("access_key", "eb501906-1925-4908-9a99-a88ca9a65ae2");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully!");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message || "Submission Failed.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "30px",
        padding: "40px",
        backgroundColor: "#f1f5f9",
        minHeight: "100vh",
      }}
    >
      {/* Contact Form */}
      <form
        onSubmit={onSubmit}
        style={{
          background: "#ffffff",
          borderRadius: "10px",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
          padding: "30px",
          width: "100%",
          maxWidth: "450px",
        }}
        data-aos="fade-right" // AOS Animation
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            color: "#1f2937",
            fontSize: "24px",
            fontWeight: "bold",
          }}
        >
          Contact Me
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "16px",
              outline: "none",
            }}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "16px",
              outline: "none",
            }}
          />
        </div>
        <div style={{ marginBottom: "25px" }}>
          <textarea
            name="message"
            placeholder="Your Message"
            required
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              fontSize: "16px",
              outline: "none",
              minHeight: "120px",
            }}
          ></textarea>
        </div>
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            background: "#2563eb",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            fontWeight: "bold",
            transition: "background 0.3s ease",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#1d4ed8")}
          onMouseLeave={(e) => (e.target.style.background = "#2563eb")}
        >
          Submit
        </button>
        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
            color: result.includes("Successfully") ? "green" : "red",
            fontSize: "14px",
          }}
        >
          {result}
        </div>
      </form>

      {/* Social Media Section */}
      <div
        style={{
          flex: "1",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        data-aos="fade-left" // AOS Animation
      >
        <SocialMedia />
      </div>
    </div>
  );
}
